$shm_hitalama_skills_item $mol_view
	entry $shm_hitalama_skills_entry
	catalog $shm_hitalama_skills_catalog
	add_skill? null
	add_group? null
	sub <= content /$mol_view
	Menu $mol_pick
		align \bottom_left
		Anchor <= Anchor $mol_check
			aria_role \presentation
			checked false
			click? null
			sub <= anchor_content /$mol_view
		event *
			^
			contextmenu? <=> contextmenu? null
		bubble_content <= menu_content /$mol_view
	Rename $mol_button_minor
		title \Переименовать
		click? <=> rename_start? null
	Add_skill $mol_button_minor
		title \Добавить скилл
		click? <=> add_skill?
	Add_group $mol_button_minor
		title \Добавить группу
		click? <=> add_group?
	Delete $shm_confirm_delete
		title <= delete_title \Удалить скилл
		question <= delete_question \Удалить скилл из каталога?
		confirmed? <=> remove? null
	Group $mol_check
		aria_role \button
		checked false
		event *
			^
			dblclick? <=> rename_start? null
		sub /
			<= Folder_icon $mol_icon_folder
			<= title \
	Link $mol_link
		arg <= link_arg *
		sub /
			<= Link_title $mol_view
				sub / <= title
			<= Link_id $mol_view
				sub / <= skill_id \
	Input $mol_string
		value? <=> draft? \
		submit? <=> rename_submit? null
		event *
			^
			blur? <=> rename_submit? null
			keydown? <=> rename_keydown? null
			pointerdown? <=> input_pointerdown? null
